import React from 'react';
import { ButtonWithGAClickButton, SectionTitle, Typography } from 'common/components';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { BANNER_IMAGE } from './header-section-constants';
import {
  headerContent,
  headerImage,
  headerSection,
  headerText,
  headerTitle,
  headerButton,
} from './header-section-styles';

type HeaderSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

/**
 * Вью секции хедера
 */
export const HeaderSection = ({ onConsultationSignupBtnClick }: HeaderSectionProps) => (
  <section className={headerSection}>
    <picture>
      <source srcSet={BANNER_IMAGE.srcDPlus} media={strictBreakpoints['--only-largeDesktop']} />
      <source srcSet={BANNER_IMAGE.srcD} media={strictBreakpoints['--only-desktop']} />
      <source srcSet={BANNER_IMAGE.srcT} media={strictBreakpoints['--only-tablet']} />
      <img alt={BANNER_IMAGE.alt} className={headerImage} src={BANNER_IMAGE.srcM} title={BANNER_IMAGE.alt} />
    </picture>
    <div className={headerContent}>
      <SectionTitle className={headerTitle} variant="display" as="h1">
        Инженерные системы для дома под ключ
      </SectionTitle>
      <Typography className={headerText} variant="l" size="body_short">
        Подберём подходящее решение и&nbsp;смонтируем систему у&nbsp;вас дома
      </Typography>

      <ButtonWithGAClickButton
        className={headerButton}
        elementBlock="landingSistemyInzhenernye"
        elementName="Инженерные системы для дома под ключ"
        elementText="Записаться на консультацию"
        onClick={onConsultationSignupBtnClick}>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </div>
  </section>
);
